let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jRTH1")).then(() => parcelRequire('ei2MK'));